<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="introduce">
      <p class="sub_title">
        服务介绍
      </p>
      <div class="content_A">
        <div>
          没有网络安全就没有国家安全， 人的安全是单位安全的最后一道防线，
          培养人员网络信息安全意识刻不容缓。 通过培训、 工具检测、
          题目检测等方式来提高单位员工安全意识， 帮助单位打造网络安全生态，
          建立完善的单位安全管理制度。
          建立单位员工对网络安全的正确认识与单位规范的管理制度，
          帮助单位规范员工日常行为，
          使员工深刻认识网络安全的重要性并按照制度进行工作。
        </div>
        <div class="content_list1">
          <div class="table_left">
            <div class="content_title">
              <div>主<br>题</div>
              <div>内容</div>
            </div>
            <div class="list">
              <div class="list_left">
                一·当前的信息安全形式
              </div>
              <div class="list_right">
                <div style="background: #5782E3">
                  当前的整体安全环境
                </div>
                <div style="background: #A7C0F5">
                  信息安全事件频发
                </div>
                <div style="background: #5782E3">
                  安全漏洞层出不穷
                </div>
                <div style="background: #A7C0F5">
                  病毒木马威胁加剧
                </div>
                <div style="background: #5782E3">
                  网络钓鱼日渐猖獗
                </div>
                <div style="background: #A7C0F5">
                  XX系统安全不容乐观
                </div>
                <div style="background: #5782E3">
                  境外攻击依然严重
                </div>
              </div>
            </div>
          </div>
          <div class="table_right">
            <div class="content_title">
              <div>内容</div>
            </div>
            <div class="list">
              <div class="list_left">
                二·个人相关安全主题
              </div>
              <div class="list_right">
                <div style="background: #5782E3">
                  1.浏览器常见安全问题与安全建议
                </div>
                <div style="background: #A7C0F5">
                  2.电子邮件常见安全问题与安全建议
                </div>
                <div style="background: #5782E3">
                  3.移动介质常见安全问题与安全建议
                </div>
                <div style="background: #A7C0F5">
                  4.即时通信常见安全问题与安全建议
                </div>
                <div style="background: #5782E3">
                  5.软件下载常见安全问题与安全建议
                </div>
                <div style="background: #A7C0F5">
                  6.商业秘密常见安全问题与安全建议
                </div>
                <div style="background: #5782E3">
                  7.物理访问常见安全问题与安全建议
                </div>
              </div>
              <div class="list_right">
                <div style="background: #5782E3">
                  8.社会工程学常见安全问题与安全建议
                </div>
                <div style="background: #A7C0F5">
                  9.口令常见安全问题与安全建议
                </div>
                <div style="background: #5782E3">
                  10.无线网络常见安全问题与安全建议
                </div>
                <div style="background: #A7C0F5">
                  11.智能手机常见安全问题与安全建议
                </div>
                <div style="background: #5782E3">
                  12.办公电脑常见安全问题与安全建议
                </div>
                <div style="background: #A7C0F5">
                  13.数据保护常见安全问题与安全建议
                </div>
                <div style="background: #5782E3">
                  14.第三方人员常见安全问题与安全建议
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="procedure">
      <p class="sub_title">
        服务流程
      </p>
      <div class="lct">
        <img
          src="@/assets/securityServices/realize1.png"
          alt=""
        >
      </div>
    </div>
    <div class="cost">
      <p class="sub_title">
        服务价值
      </p>
      <div class="lists">
        <div
          v-for="item in costList"
          :key="item.id"
          class="list"
        >
          <div class="item_list">
            <img
              :src="item.imgUrl"
              alt=""
            >
            <div class="content">
              <p>{{ item.title }}</p>
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Realize',
  components: {
    banner
  },
  data() {
    return {
      title: '安全意识培训',
      content:
        '安全技术和产品无法保护每一个人远离每一种可能存在的安全风险。 通过提升全员的信息安全意识， 让办公人员建立起保护单位的责任感， 是单位面对安全威胁的最佳方式。',
      costList: [
        {
          id: 1,
          title: '完善安全知识技能',
          imgUrl: require('@/assets/securityServices/realize2.png'),
          content: '帮助客户建立网络安全生态，完善人员安全知识技能。'
        },
        {
          id: 2,
          title: '提升风险管理水准',
          imgUrl: require('@/assets/securityServices/realize3.png'),
          content:
            '协助客户切实改善风险管理水平，提高员工网络安全素质，提升单位整体安全水平。'
        },
        {
          id: 3,
          title: '满足合规合法要求',
          imgUrl: require('@/assets/securityServices/realize4.png'),
          content:
            '满足等级保护关于安全管理制度、安全管理机构、安全管理人员相关要求。'
        }
      ]
    }
  }
}
</script>
<style scoped>
@import '../../styles/utils.scss';
</style>
<style lang="less" scoped>
.content_list1 {
  margin-top: 63px;
  display: flex;
  justify-content: space-between;

  .content_title {
    display: flex;
    align-content: center;
    align-items: center;
    background: #5782e3;
    font-size: 24px;
    font-weight: bold;
    color: #ffffff;
    height: 80px;
    div:nth-child(1) {
      margin-left: 20px;
    }
    div:nth-child(2) {
      margin-left: calc(50% - 72px);
    }
  }

  .table_left {
    width: 30%;
    .list {
      display: flex;
      justify-content: space-around;
      div {
        text-indent: 1em;
        font-size: 20px;
      }

      .list_left {
        writing-mode: tb-rl;
        background: #5782e3;
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
        line-height: 62px;
        letter-spacing: 10px;
        padding: 20px 0;
        margin-top: 6px;
      }
      .list_right {
        width: calc(100% - 68px);
        margin-left: 6px;
        div {
          width: 100%;
          padding: 10px 0;
          color: #fff;
          margin-top: 6px;
        }
      }
    }
  }
  .table_right {
    width: calc(70% - 6px);

    .content_title div {
      margin-left: calc(50% - 48px);
    }
    .list {
      display: flex;
      justify-content: space-around;
      div {
        text-indent: 1em;
        font-size: 20px;
      }

      .list_left {
        writing-mode: tb-rl;
        background: #5782e3;
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
        line-height: 62px;
        letter-spacing: 10px;
        padding: 20px 0;
        margin-top: 6px;
      }
      .list_right {
        width: calc(50% - 12px);
        margin-left: 6px;
        div {
          width: 100%;
          padding: 10px 0;
          color: #fff;
          margin-top: 6px;
        }
      }
    }
  }
}
@media (min-width: 1200px)and (max-width: 1350px){
  .content_A div{
    font-size: 20px;
  }
}
@media (max-width: 1270px) {
  .list_right div {
    font-size: 17px !important;
    text-indent: 0.8em;
  }
  .list_left {
    font-size: 21px !important;
  }
}
@media screen and (min-width: 1270px) and (max-width: 1600px) {
  .list_right div {
    font-size: 18px !important;
    text-indent: 0.8em;
  }
  .list_left {
    font-size: 22px !important;
  }
}
</style>
